import React, { useEffect } from "react"
import { Card, CardContent } from "../../../ui/card"
import AOS from "aos"
import "aos/dist/aos.css"
import {
  BookOpen,
  DollarSign,
  Headphones,
  Heart,
  Users,
  Monitor,
  Baby,
  BarChart
} from "lucide-react"

const BenefitsSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out"
    })
  }, [])

  const benefits = [
    {
      title: "Career growth path",
      description:
        "Clear advancement opportunities and personalized development plans.",
      icon: <BookOpen className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
    },
    {
      title: "Competitive salary",
      description: "We value great talent and compensate accordingly.",
      icon: (
        <DollarSign className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
      )
    },
    {
      title: "Learning budget",
      description:
        "Budget for courses, books, and conferences to keep growing.",
      icon: (
        <Headphones className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
      )
    },
    {
      title: "Health & wellness",
      description: "Comprehensive health coverage and wellness programs.",
      icon: <Heart className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
    },
    {
      title: "Team retreats",
      description: "Regular offsites to connect, celebrate and have fun.",
      icon: <Users className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
    },
    {
      title: "Build your own setup",
      description: "Budget for your perfect workstation and software.",
      icon: <Monitor className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
    },
    {
      title: "Family support",
      description: "Generous parental leave and childcare benefits.",
      icon: <Baby className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
    },
    {
      title: "Ownership & impact",
      description: "Equity options and direct impact on company success.",
      icon: <BarChart className="h-6 w-6 sm:h-8 sm:w-8 text-oye-purple mb-2" />
    }
  ]

  return (
    <section className="py-8 sm:py-10 md:py-12 lg:py-16 bg-gradient-to-b from-white to-oye-light-purple">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-10 md:mb-12" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 md:mb-5 text-black">
            Why you'll <span className="text-[#E563A4]">love it</span> here
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
            Beyond building something amazing, these are the perks that make Oye
            Creator a place where people thrive.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
          {benefits.map((benefit, index) => (
            <Card
              key={index}
              className="bg-white/70 backdrop-blur-sm transition-all duration-300 hover:shadow-md hover:scale-105 rounded-xl md:rounded-2xl border-none overflow-hidden"
              data-aos="fade-up"
              data-aos-delay={(index % 4) * 100}
            >
              <CardContent className="pt-4 sm:pt-5 flex flex-col items-center text-center p-4 sm:p-5">
                {benefit.icon}
                <h3 className="text-base sm:text-lg font-semibold mb-1 sm:mb-2">
                  {benefit.title}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600">
                  {benefit.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BenefitsSection
